// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"412":"b8dbe2e1","537":"4e1b760a","554":"b8dbe2e1","824":"f60b460a","943":"ac7b0b01"}[chunkId] + ".chunk.css";
};